module.exports = __webpack_public_path__ + "img/symbol_9.640dd53c.png";